module.exports = __webpack_public_path__ + "static/media/semi_detached_blue.d77493c4.svg";